<template>
  <div id="app">
    <top-menu v-if="!noshow" />

    <div class="blank" />
    <!-- <keep-alive>
  <router-view />
</keep-alive> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <!-- <robot style="position: fixed;right:150px;bottom:80px" /> -->
    <VueBotUI class="iphone" :messages="data" :options="botOptions" @msg-send="messageSendHandler" :input-disable="true" v-if="currentLanguage==0" />
    <VueBotUI class="iphone" :messages="cndata" :options="cnbotOptions" @msg-send="cnmessageSendHandler" :input-disable="true" v-else />

    <div class="cookies" v-if="cookies">{{currentLanguage==0?"This website uses cookies to improve your experience. We'll assume you're ok with this, but you can opt-out if you wish":"本网站使用cookies来改善您的体验。我们预设您同意这样。您也可以选择拒绝。"}} <span class="settings" @click="dialogVisible=true;">{{currentLanguage==0?"Cookie settings":"Cookie设置"}}</span> <button @click="getcookies()">{{currentLanguage==0?"ACCEPT":"接受"}}</button> <button @click="nocookies()">{{currentLanguage==0?"REJECT":"拒绝"}}</button></div>
    <div v-if="currentLanguage==0">
      <el-dialog title="Privacy Overview" :visible.sync="dialogVisible" width="50%">
        <span>
          <div>This website uses cookies to improve your experience while you navigate through the website. Out of these cookies, the cookies that are categorized as necessary are stored on your browser as they are essential for the working of basic functionalities of the website. We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent. You also have the option to opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing experience.</div>
          <div class="Necessary">
            <el-collapse>

              <el-collapse-item title="Necessary" name="1">

                <div>Necessary cookies are absolutely essential for the website to function properly. This category only includes cookies that ensures basic functionalities and security features of the website. These cookies do not store any personal information.</div>
              </el-collapse-item>
              <div class="right">
                <div>Always Enabled</div>

              </div>
              <el-collapse-item title="Non-Necessary" name="2">
                <div>We’d like to set analytic software i.e. Google Analytics/Click Dimensions to help us improve our website by collecting and reporting information on how you use it. The cookies collect information in a way that does not directly identify anyone. For more information on how these cookies work, please see our Cookies Policy.</div>
              </el-collapse-item>
            </el-collapse>
            <div class="right">
              <div @click="!value1">
                <el-switch v-model="value1" active-text="Enabled" inactive-text="Disabled">
                </el-switch>
              </div>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="activeChange()">SAVE & ACCEPT</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-else>
      <el-dialog title="隐私概述" :visible.sync="dialogVisible" width="50%">
        <span>
          <div>本网站使用cookies来改善您浏览网站时的体验。在这些cookies中，被归类为必要的cookies被存储在您的浏览器上，因为它们对网站基本功能的运行至关重要。我们还使用第三方cookies，帮助我们分析和了解您如何使用本网站。这些cookies只有在您同意的情况下才会储存在您的浏览器中。你也可以选择退出这些cookies。但选择退出其中一些cookies可能会对您的浏览体验产生影响。</div>
          <div class="Necessary">
            <el-collapse>

              <el-collapse-item title="必要的" name="1">

                <div>必要的cookies对于网站的正常运行是绝对必须的。这一类别只包括确保网站基本功能和安全特性的cookies。这些cookies不存储任何个人信息。</div>
              </el-collapse-item>
              <div class="right">
                <div>总是启用</div>

              </div>
              <el-collapse-item title="非必要的" name="2">
                <div>我们想设置分析软件，即谷歌分析/点击统计，通过收集和报告您如何使用网站的信息，帮助我们改进网站。这些cookies收集信息的方式不会直接识别任何人。关于这些cookies如何工作的更多信息，请参见我们的Cookies政策。</div>
              </el-collapse-item>
            </el-collapse>
            <div class="right">
              <div @click="!value1">
                <el-switch v-model="value1" active-text=" 已启用" inactive-text="未启用">
                </el-switch>
              </div>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="activeChange()">保存并确认</el-button>
        </span>
      </el-dialog>
    </div>
    <bottom v-if="!noshow" :changecookies="changecookies" />
    <!-- <robot></robot> -->
  </div>
</template>
<script>
import TopMenu from "./components/topMenu";
import Bottom from "./components/bottom";
// import '@/config/rem'
import { robotRecord } from "@/api/api";
import Robot from "./components/robot";
import { VueBotUI } from "vue-bot-ui";
// import { messageService } from "./components/robot/message";
export default {
  data() {
    return {
      botTyping: true,
      value1: true,
      dialogVisible: false,
      cookies: false,
      data: [
        {
          agent: "bot", // 必需。'bot' 或 'user'
          type: "button", // 必需。气泡消息组件类型：'text' / 'button'
          text: "Would you like to request a bid?", // 必需的。消息
          options: [
            {
              text: "Yes",
              value: "/contact?source=robot",
              action: "postback"
            }
          ]
        },
        {
          agent: "bot",
          type: "button",
          text: "You have questions, we have answers 😊 How can I help?",
          options: [
            {
              text: "I would like a research consultation",
              action: "postback"
            },
            {
              text: "I would like a consultation with an industry expert",
              action: "postback"
            },
            {
              text: "I would like to be a partner supplier",
              value: "contact?source=robot",
              action: "postback"
            }
          ]
        }
      ], //消息数据
      botOptions: {
        botTitle: "Holden",
        botAvatarImg: "" //机器人头像图片地址
      }, //自定义 UI 的一些选项
      cndata: [
        {
          agent: "bot", // 必需。'bot' 或 'user'
          type: "button", // 必需。气泡消息组件类型：'text' / 'button'
          text: "你想咨询吗?", // 必需的。消息
          options: [
            {
              text: "是的",
              value: "/cn/contact?source=robot",
              action: "postback"
            }
          ]
        },
        {
          agent: "bot",
          type: "button",
          text: "你有问题，我们就有答案😊我能为你做些什么?",
          options: [
            {
              text: "我想要一个研究咨询",
              action: "postback"
            },
            {
              text: "我想咨询一下行业专家",
              action: "postback"
            },
            {
              text: "我想成为合作伙伴供应商",
              value: "/cn/contact?source=robot",
              action: "postback"
            }
          ]
        }
      ], //消息数据
      cnbotOptions: {
        botTitle: "浩顿",
        botAvatarImg: "" //机器人头像图片地址
      } //自定义 UI 的一些选项
    };
  },
  components: {
    TopMenu,
    Bottom,
    VueBotUI,
    Robot
  },
  computed: {
    noshow() {
      return this.$route.name == "Unsubscribe";
    },
    isPC() {
      return this.$store.state.isPC;
    },
    currentLanguage() {
      return Number(this.$store.state.lang);
    }
  },
  created() {
    this.ifcookies();
    this.defaultcookies();
    this.remove();
  },
  methods: {
    
    // 设置默认cookies
    defaultcookies() {
      if (!localStorage.getItem("agreeCookies")) {
        this.$cookies.set("defaultcookies", "true");
      }
    },
    // 如果同意的话就设置一个cookies，并且在localStorage中记录
    getcookies() {
      this.$cookies.set("holdencookies", "holdencookies", 31536000);
      var curtime = new Date().getTime();
      localStorage.setItem("agreeCookies", JSON.stringify({ val: "agree", time: curtime }));
      this.dialogVisible = false;
      this.cookies = false;
    },
    // 如果不同意的话就删除defaulecookies，并且在localStorage中记录
    nocookies() {
      var curtime = new Date().getTime();
      localStorage.setItem("agreeCookies", JSON.stringify({ val: "disagree", time: curtime }));
      // 删除默认的cookies
      this.$cookies.remove("defaultcookies");
      // 删除同意的cookies
      this.$cookies.remove("holdencookies");
      // 删除填写信息的cookies
      this.$cookies.remove("HoldenCookies");

      this.dialogVisible = false;
      this.cookies = false;
    },
    // 如果localStorage超过一年时间就自动删除
    remove() {
      if (localStorage.getItem("agreeCookies")) {
        var val = localStorage.getItem("agreeCookies");
        var dataobj = JSON.parse(val);

        var newTime = new Date().getTime();
        if (newTime - dataobj.time > 1000 * 60 * 60 * 24 * 365) {
          localStorage.removeItem("agreeCookies");
        }
      }
    },
    ifcookies() {
      if (window.location.pathname.includes("/cn/activity") || window.location.pathname.includes("/cn/activityFinished")) {
        this.cookies = false;
      } else if (!localStorage.getItem("agreeCookies")) {
        // 如果没有localStorage的话就显示下面那一条
        this.cookies = true;
      }
    },
    // cookies内部的开关设置
    activeChange() {
      if (this.value1 == true) {
        this.getcookies();
      } else if (this.value1 == false) {
        this.nocookies();
      }
      dialogVisible = false;
      cookies = false;
    },
    // botStart() {
    //   //初始化 会发送什么
    //   this.botTyping = true;
    //   setTimeout(() => {
    //     this.botTyping = false;
    //     this.data.push({

    //     });
    //   }, 1000);
    // },
    messageSendHandler(value) {
      this.data.push({
        agent: "user",
        type: "text",
        text: value.text
      });
      if (value.text == "Yes") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "Would you like to request a bid?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }
      // 第一个问题第一个选项
      if (value.text == "I would like a research consultation") {
        const replyMessage = {
          agent: "bot",
          type: "button",
          text: "Great, we'd love to help you get to the right spot! What are you interested in?",
          options: [
            {
              text: "Qualitative",
              action: "postback"
            },
            {
              text: "Quantitative",
              action: "postback"
            },
            {
              text: "Asia Panels",
              action: "postback"
            },
            {
              text: "Request a consultation",
              value: "contact?source=robot"
            }
          ]
        };
        this.data.push(replyMessage);
        robotRecord({
          question: "You have questions, we have answers 😊 How can I help?",
          answer: value.text,
          link: "",
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }

      // 第一个问题第二个选项
      if (value.text == "I would like a consultation with an industry expert") {
        const replyMessage = {
          agent: "bot",
          type: "button",
          text: "Which industry are you interested in?",
          options: [
            {
              text: "Healthcare",
              value: "contact?source=robot",
              action: "postback"
            },
            {
              text: "Medtech",
              value: "contact?source=robot",
              action: "postback"
            },
            {
              text: "Consumer",
              value: "contact?source=robot",
              action: "postback"
            }
          ]
        };
        this.data.push(replyMessage);
        robotRecord({
          question: "You have questions, we have answers 😊 How can I help?",
          answer: value.text,
          link: "",
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }
      // 第一个问题第二个选项后续
      if (value.text == "Healthcare" || value.text == "Medtech" || value.text == "Consumer") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "Which industry are you interested in?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }
      // 第一个问题第三、四个选项
      if (value.text == "I would like to be a partner supplier" || value.text == "Feedback") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "You have questions, we have answers 😊 How can I help?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }

      // 第二个问题第一个选项
      if (value.text == "Qualitative") {
        const replyMessage = {
          agent: "bot",
          type: "button",
          text: "Last question, is there a particular digital qual method you are looking to discuss?",
          options: [
            {
              text: "IDI",
              value: "interview?source=robot",
              action: "postback"
            },
            {
              text: "FGP",
              value: "focus?source=robot",
              action: "postback"
            },
            {
              text: "Dyad",
              value: "focus?source=robot",
              action: "postback"
            },
            {
              text: "Triad",
              value: "focus?source=robot",
              action: "postback"
            },
            {
              text: "Ethnography",
              value: "ethnography?source=robot",
              action: "postback"
            },
            {
              text: "Gang Survey",
              value: "gangsurvey?source=robot",
              action: "postback"
            },
            {
              text: "Request a consultation",
              value: "contact?source=robot",
              action: "postback"
            }
          ]
        };
        const reply = {
          agent: "bot",
          type: "text",
          text: "We have a broad range of digital qualitative solutions and platforms."
        };
        this.data.push(reply);

        this.data.push(replyMessage);
        robotRecord({
          question: "Great, we'd love to help you get to the right spot! What are you interested in?",
          answer: value.text,
          link: "",
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }
      // 第二个问题第二个
      if (value.text == "Quantitative") {
        const replyMessage = {
          agent: "bot",
          type: "button",
          text: "Last question, would you like to talk with a team member about any of these quantitative solutions?",
          options: [
            {
              text: "Online Survey",
              value: "onlinesurvey?source=robot",
              action: "postback"
            },
            {
              text: "Modeling & Analytics",
              value: "modeling?source=robot",
              action: "postback"
            },
            {
              text: "Programming & Processing",
              value: "programming?source=robot",
              action: "postback"
            },
            {
              text: "Request a consultation",
              value: "contact?source=robot",
              action: "postback"
            }
          ]
        };
        const reply = {
          agent: "bot",
          type: "text",
          text: "Our clients trust our online surveys and advanced programmatic solutions. We also have a broad range of additional quantitative methodologies."
        };
        this.data.push(reply);

        this.data.push(replyMessage);
        robotRecord({
          question: "Great, we'd love to help you get to the right spot! What are you interested in?",
          answer: value.text,
          link: "",
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }
      // 第二个问题第三个
      if (value.text == "Asia Panels") {
        const replyMessage = {
          agent: "bot",
          type: "button",
          text: "Which industry are you interested in?",
          options: [
            {
              text: "HCPs",
              value: "physicians?source=robot",
              action: "postback"
            },
            {
              text: "Patients",
              value: "patients?source=robot",
              action: "postback"
            },
            {
              text: "Consumers",
              value: "consumer?source=robot",
              action: "postback"
            }
          ]
        };
        const reply = {
          agent: "bot",
          type: "text",
          text: "Asia is Our Base. Our panel Covers 14 countries & markets, with population over 10 million people"
        };
        this.data.push(reply);

        this.data.push(replyMessage);
        robotRecord({
          question: "Great, we'd love to help you get to the right spot! What are you interested in?",
          answer: value.text,
          link: "",
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }
      // 第二个问题第四个选项
      if (value.text == "Request a consultation") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "Great, we'd love to help you get to the right spot! What are you interested in?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }

      if (value.text == "IDI" || value.text == "FGP" || value.text == "Dyad" || value.text == "Triad" || value.text == "Ethnography" || value.text == "Gang Survey") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "Last question, is there a particular digital qual method you are looking to discuss?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }
      if (value.text == "Online Survey" || value.text == "Modeling & Analytics" || value.text == "Programming & Processing") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "Last question, would you like to talk with a team member about any of these quantitative solutions?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }
      if (value.text == "HCPs" || value.text == "Patients" || value.text == "Consumers") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "Which industry are you interested in?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            console.log("success");
          }
        });
      }
      // this.getResponse();
    },
    cnmessageSendHandler(value) {
      this.cndata.push({
        agent: "user",
        type: "text",
        text: value.text
      });
      if (value.text == "是的") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "你想咨询吗?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }
      // 第一个问题第一个选项
      if (value.text == "我想要一个研究咨询") {
        const replyMessage = {
          agent: "bot",
          type: "button",
          text: "太好了，我们很乐意帮助你到达正确的地点!你对什么感兴趣?",
          options: [
            {
              text: "定性",
              action: "postback"
            },
            {
              text: "定量",
              action: "postback"
            },
            {
              text: "亚洲板块",
              action: "postback"
            },
            {
              text: "请求咨询",
              value: "/cn/contact?source=robot"
            }
          ]
        };
        this.cndata.push(replyMessage);
        robotRecord({
          question: "你有问题，我们就有答案😊我能为你做些什么?",
          answer: value.text,
          link: "",
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }

      // 第一个问题第二个选项
      if (value.text == "我想咨询一下行业专家") {
        const replyMessage = {
          agent: "bot",
          type: "button",
          text: "你对哪个行业感兴趣?",
          options: [
            {
              text: "医疗保健服务",
              value: "/cn/contact?source=robot",
              action: "postback"
            },
            {
              text: "医疗器械",
              value: "/cn/contact?source=robot",
              action: "postback"
            },
            {
              text: "消费者",
              value: "/cn/contact?source=robot",
              action: "postback"
            }
          ]
        };
        this.cndata.push(replyMessage);
        robotRecord({
          question: "你有问题，我们就有答案😊我能为你做些什么?",
          answer: value.text,
          link: "",
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }
      // 第一个问题第二个选项后续
      if (value.text == "医疗保健服务" || value.text == "医疗器械" || value.text == "消费者") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "你对哪个方面感兴趣？",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }
      // 第一个问题第三、四个选项
      if (value.text == "我想成为合作伙伴供应商" || value.text == "反馈") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "你有问题，我们就有答案😊我能为你做些什么?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }

      // 第二个问题第一个选项
      if (value.text == "定性") {
        const replyMessage = {
          agent: "bot",
          type: "button",
          text: "最后一个问题，你想讨论一种特殊的数字质量方法吗?",
          options: [
            {
              text: "IDI深度访谈",
              value: "/cn/interview?source=robot",
              action: "postback"
            },
            {
              text: "小组座谈会",
              value: "/cn/focus?source=robot",
              action: "postback"
            },
            {
              text: "1V1",
              value: "/cn/focus?source=robot",
              action: "postback"
            },
            {
              text: "1V2",
              value: "/cn/focus?source=robot",
              action: "postback"
            },
            {
              text: "Ethnography",
              value: "/cn/ethnography?source=robot",
              action: "postback"
            },
            {
              text: "Gang Survey",
              value: "/cn/gangsurvey?source=robot",
              action: "postback"
            },
            {
              text: "请求咨询",
              value: "/cn/contact?source=robot",
              action: "postback"
            }
          ]
        };
        const reply = {
          agent: "bot",
          type: "text",
          text: "我们拥有广泛的数字定性解决方案和平台。"
        };
        this.cndata.push(reply);

        this.cndata.push(replyMessage);
        robotRecord({
          question: "太好了，我们很乐意帮助你到达正确的地点！你对什么感兴趣?",
          answer: value.text,
          link: "",
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }
      // 第二个问题第二个
      if (value.text == "定量") {
        const replyMessage = {
          agent: "bot",
          type: "button",
          text: "最后一个问题，你想和团队成员谈谈这些定量解决方案吗?",
          options: [
            {
              text: "线上调查",
              value: "/cn/onlinesurvey?source=robot",
              action: "postback"
            },
            {
              text: "建模与分析",
              value: "/cn/modeling?source=robot",
              action: "postback"
            },
            {
              text: "编程与数据处理",
              value: "/cn/programming?source=robot",
              action: "postback"
            },
            {
              text: "请求咨询",
              value: "/cn/contact?source=robot",
              action: "postback"
            }
          ]
        };
        const reply = {
          agent: "bot",
          type: "text",
          text: "客户信赖我们的在线调查和先进的程序化解决方案。我们也有广泛的其他定量方法。"
        };
        this.cndata.push(reply);

        this.cndata.push(replyMessage);
        robotRecord({
          question: "太好了，我们很乐意帮助你到达正确的地点！你对什么感兴趣?",
          answer: value.text,
          link: "",
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }
      // 第二个问题第三个
      if (value.text == "Asia Panels") {
        const replyMessage = {
          agent: "bot",
          type: "button",
          text: "你对哪个方面感兴趣？",
          options: [
            {
              text: "医生",
              value: "/cn/physicians?source=robot",
              action: "postback"
            },
            {
              text: "患者",
              value: "/cn/patients?source=robot",
              action: "postback"
            },
            {
              text: "消费者们",
              value: "/cn/consumer?source=robot",
              action: "postback"
            }
          ]
        };
        const reply = {
          agent: "bot",
          type: "text",
          text: "亚洲是我们的基础。我们的业务覆盖4个市场，人口超过1000万"
        };
        this.cndata.push(reply);

        this.cndata.push(replyMessage);
        robotRecord({
          question: "太好了，我们很乐意帮助你到达正确的地点！你对什么感兴趣?",
          answer: value.text,
          link: "",
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }
      // 第二个问题第四个选项
      if (value.text == "请求咨询") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "太好了，我们很乐意帮助你到达正确的地点！你对什么感兴趣?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }

      if (value.text == "IDI深度访谈" || value.text == "小组座谈会" || value.text == "1V1" || value.text == "1V2" || value.text == "Ethnography" || value.text == "Gang Survey") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "最后一个问题，你想讨论一种特殊的数字质量方法吗?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }
      if (value.text == "线上调查" || value.text == "建模与分析" || value.text == "编程与数据处理") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "最后一个问题，你想和团队成员谈谈这些定量解决方案吗?",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }
      if (value.text == "医生" || value.text == "患者" || value.text == "消费者们") {
        let pathInfo = this.$router.resolve({
          path: value.value
        });
        window.open(pathInfo.href, "_blank");
        robotRecord({
          question: "你对哪个方面感兴趣？",
          answer: value.text,
          link: value.value,
          firstName: "",
          fullName: "",
          information: ""
        }).then(res => {
          if (res.code === 1000) {
            // console.log("success");
          }
        });
      }
      // this.getResponse();
    },
    // getResponse() {
    //   this.botTyping = true;
    //   messageService.createMessage().then(response => {
    //     const replyMessage = {
    //       agent: "bot",
    //       ...response
    //     };
    //     this.data.push(replyMessage);

    //     // finish
    //     this.botTyping = false;
    //   });
    // },
    changecookies(status) {
      this.cookies = status;
    }
  }
};
</script>

<style lang="scss" scoped>
.qkb-bot-ui {
  bottom: 60px;
  right: 100px;
}
/deep/.qkb-board {
  border: 1px solid #ccc;
}
/deep/.qkb-board-action {
  display: none !important;
}
/deep/.qkb-mb-button-options__item {
  text-align: start;
  flex: inherit;
  .qkb-mb-button-options__btn {
    span {
      display: flex;
      text-align: start;
    }
  }

  // text-align: center;
}
#app {
  // font-size: 0.14rem;
  width: 100%;
}
.marginTop10 {
  margin-top: 0.1rem;
}
.centerContent {
  min-height: calc(100vh - 3.7rem);
}
.padTop {
  padding-top: 1.2rem;
}
.blank {
  height: 82px;
}
.cookies {
  border-top: 1px solid #ccc;
  background-color: #fff;
  height: 60px;
  position: fixed;
  width: 100%;
  z-index: 999;
  bottom: 0;
  text-align: center;
  padding-top: 12px;
  font-size: 18px;
  .settings {
    cursor: pointer;
    color: #2cb1e9;
  }
  button {
    cursor: pointer;

    border: none;
    background-color: #2cb1e9;
    color: #fff;
    padding: 5px 10px;
  }
}
/deep/.el-collapse-item__arrow {
  // margin: 0;
}
/deep/.el-collapse {
  border: none;
  width: 100%;
  word-break: break-word;
}
/deep/ .el-collapse-item__header {
  border: none;
}
// .Necessary {
//   margin-top: 50px;
//   display: flex;
//   justify-content: space-between;
//   .right {
//     line-height: 50px;
//   }
// }
.right {
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
}
@media screen and (max-width: 576px) {
  /deep/.qkb-board {
    // left: 0px;
    right: 400px;
    bottom: 800px;
    width: 520px;
    height: 730px;
    transform: scale(2.8);
  }
  /deep/.qkb-board-header {
    height: 60px;
  }
  /deep/.qkb-board-content__bubbles {
    padding: 10px;
  }

  .cookies {
    height: 500px;
    font-size: 70px;
    button {
      font-size: 70px;
    }
  }
  .Necessary {
    margin-top: 50px;
    .right {
      line-height: 200px;
    }
  }
  /deep/.el-switch__label {
    & > span {
      font-size: 60px;
    }
  }
  /deep/.el-switch__core {
    height: 50px;
  }
  /deep/.el-dialog__wrapper {
    .el-dialog {
      padding: 50px;
      width: 100% !important;
      .el-dialog__header {
        .el-dialog__title {
          font-size: 70px;
        }
      }
      .el-dialog__body {
        font-size: 70px;
        word-break: break-word;
        padding: 10px !important;
        overflow-y: auto;
        height: 1500px !important;
      }
      .el-dialog__footer {
        .el-button {
          font-size: 70px;
          padding: 20px;
        }
      }
    }
  }
  /deep/.el-collapse {
    border: none;
    font-size: 70px;
    .el-collapse-item {
      // border-top: 10px solid #2cb1e9;
    }
    .el-collapse-item__header {
      color: #707071;
      height: 100px;
      border: none;
      font-size: 80px;
      font-weight: 700;
    }
    .el-collapse-item__content {
      padding: 0;
      margin-top: 35px;
      div {
        padding: 8px;
        font-size: 75px;
      }
    }
  }
}
</style>
